import React, { useState } from "react";
import emailicon from "../../images/emailchecker.png";
import { Link } from "react-router-dom";
import { RESET_PASSWORD } from "../../mutation/ResetPassword";
import { useMutation } from "@apollo/react-hooks";
import FullWidthLayout from "./FullWidthLayout";

const EmailVerify = () => {
  const [ResendEmail] = useMutation(RESET_PASSWORD);
  const [resendEmailError, setResendEmailError] = useState("");
  const emailID = localStorage.getItem("resend_forgot_password_email")
    ? localStorage.getItem("resend_forgot_password_email")
    : "abc@abc.com";

  const clickHandler = () => {
    ResendEmail({
      variables: {
        email: emailID,
      },
    }).catch((e) => {
      const errors = e.graphQLErrors;
      if (errors[0] && errors[0].message) {
        setResendEmailError(errors[0].message);
      }
    });
  };

  return (
    <FullWidthLayout>
      <div className="login-cover email-verify">
        <div className="login-box">
          {/* <div className="left-arrow">
                    <Link to="/reset-password">
                    <img src={arrow} alt="arrow" />
                    </Link>
                </div> */}
          <div className="email-verify">
            <div className="icon">
              <img src={emailicon} alt="icon" />
            </div>
            <h1 style={{ fontSize: "24px", fontWeight: "600" }}>
              Check your Email
            </h1>
            <p>We have sent you an email with reset password instructions.</p>
            {/* <p>Did’t received any email? <Link to="#" onClick={clickHandler}>Re-send</Link></p> */}
            <div className="email-verify-button">
              <Link to="#" onClick={clickHandler} className="resend-email-btn">
                Resend email
              </Link>
              <Link to="/login" className="signin-btn">
                Sign in
              </Link>
            </div>
            <div
              className="error-message"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              {resendEmailError}
            </div>
          </div>
        </div>
      </div>
    </FullWidthLayout>
  );
};

export default EmailVerify;
